import { type FC } from 'react';
import { type User } from '@/api/admin/user';
import { UiSimpleGrid, UiStack, UiText, UiLink } from '@/lib/ui';

export interface SocialLinksSectionProps {
  user: User
}

const SocialLink: FC<{ label: string; value?: string | null }> = ({ label, value }) => {
  const isUrl = value && (value.startsWith('http://') || value.startsWith('https://'));
  
  return (
    <UiStack>
      <UiText color={'text.secondary'}>{label}</UiText>
      {isUrl ? (
        <UiLink href={value} isExternal color={'primary.500'}>
          {value}
        </UiLink>
      ) : (
        <UiText>{value || 'N/A'}</UiText>
      )}
    </UiStack>
  );
};

const SocialLinksSection: FC<SocialLinksSectionProps> = ({ user }) => {
  return (
    <UiSimpleGrid columns={4} gap={8}>
      <SocialLink label="Facebook" value={user.facebook} />
      <SocialLink label="Twitter" value={user.twitter} />
      <SocialLink label="LinkedIn" value={user.linkedin} />
      <SocialLink label="Instagram" value={user.instagram} />
      <SocialLink label="WeChat" value={user.wechat} />
    </UiSimpleGrid>
  );
};

export default SocialLinksSection;